// Parse admin-provided URLs into safe embeds for YouTube / Facebook / Telegram / MP4

export function youtubeId(url = '') {
  const patterns = [
    /youtu\.be\/([A-Za-z0-9_-]{6,})/,
    /youtube\.com\/watch\?v=([A-Za-z0-9_-]{6,})/,
    /youtube\.com\/embed\/([A-Za-z0-9_-]{6,})/,
    /youtube\.com\/shorts\/([A-Za-z0-9_-]{6,})/,
  ];
  for (const p of patterns) { const m = url.match(p); if (m) return m[1]; }
  return null;
}

export function buildEmbed(platform = '', url = '') {
  const p = String(platform).toLowerCase();
  if (!url) return { kind: 'link', src: '', fallback: '' };

  if (p === 'youtube') {
    const id = youtubeId(url);
    if (id) {
      return {
        kind: 'iframe',
        src: `https://www.youtube.com/embed/${id}?rel=0&modestbranding=1&playsinline=1`,
        fallback: url,
        thumbnail: `https://i.ytimg.com/vi/${id}/hqdefault.jpg`,
      };
    }
  }
  if (p === 'facebook') {
    const encoded = encodeURIComponent(url);
    return {
      kind: 'iframe',
      src: `https://www.facebook.com/plugins/video.php?href=${encoded}&show_text=false&width=560&t=0`,
      fallback: url,
      thumbnail: null,
    };
  }
  if (p === 'telegram') {
    const m = url.match(/t\.me\/([^/?#]+)\/(\d+)/);
    if (m) {
      return {
        kind: 'telegram',
        src: `https://t.me/${m[1]}/${m[2]}?embed=1&mode=tme`,
        fallback: url,
        thumbnail: null,
      };
    }
    return { kind: 'link', src: url, fallback: url };
  }
  if (p === 'mp4' || p === 'direct') {
    return { kind: 'video', src: url, fallback: url };
  }
  return { kind: 'link', src: url, fallback: url };
}
